import React  from 'react';
import { ManageEndorsements } from '../../../components/HOC/HOCDecoratedComponents';

export const Endorsements = ( props ) => {
    const { childrenData, guestMode } = props;
    return (
            <ManageEndorsements
                guestMode={ guestMode }
                componentData={ childrenData }
                actionName="endorsementsApiCall" />
    )
};

export default Endorsements;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/endorsements/Endorsements.js